"use client";

import { useState } from "react";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { motion, useMotionValueEvent, useScroll } from "motion/react";

import { Button } from "@/components/ui/button";

import { cn } from "@/lib/utils";

import Logo from "@/assets/logo.svg";

const NAV_LINKS = [
  { label: "The Solution", href: "/#the-solution" },
  { label: "Value", href: "/#value" },
  { label: "Platform", href: "/#platform" },
  { label: "Style Intelligence", href: "/#style-intelligence" },
];

const CTA = { label: "Join the Waitlist", href: "/request-access" };

export default function Navbar() {
  const pathname = usePathname();
  const { scrollY } = useScroll();
  const [hidden, setHidden] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // is homepage
  const isHomepage = pathname === "/";

  useMotionValueEvent(scrollY, "change", () => {
    if (scrollY.current < scrollY.prev) {
      setHidden(false);
    } else if (scrollY.current > 50 && scrollY.current > scrollY.prev) {
      setHidden(true);
    }
    setScrolled(scrollY.current > 100);
  });

  return (
    <motion.nav
      className={cn(
        "absolute lg:fixed top-0 z-50 border-b transition-colors duration-700  w-full",
        scrolled
          ? "border-b border-gray-100 bg-white text-foreground"
          : "border-transparent text-white",
      )}
      animate={hidden ? "hidden" : "visible"}
      variants={{ hidden: { y: "-100%" }, visible: { y: 0 } }}
      transition={{ ease: "easeInOut", duration: 0.4 }}
    >
      <div className="content grid grid-cols-[1fr_1fr] md:grid-cols-[150px_1fr_150px] items-center justify-between gap-x-6 gap-y-3 py-4">
        <Link
          href="/"
          className="flex shrink-0 items-center gap-2 max-w-[150px] hover:text-primary-400 duration-300"
        >
          <Logo
            className="h-4 md:h-8 w-auto text-current"
            aria-label="Maura home"
          />
        </Link>
        <div className="flex min-w-0 flex-1 justify-center items-center gap-6 sm:gap-8 max-md:hidden">
          {isHomepage
            ? NAV_LINKS.map((link) => (
                <Button
                  key={link.label}
                  variant={scrolled ? "link-secondary" : "link-white"}
                  asChild
                  className={cn(
                    "px-0 font-medium uppercase",
                    pathname === link.href && "text-white",
                  )}
                >
                  <Link href={link.href}>{link.label}</Link>
                </Button>
              ))
            : null}
        </div>
        <Button
          asChild
          className="shrink-0 max-w-[150px] ml-auto"
          arrow
          variant={scrolled ? "default" : "outline"}
        >
          <Link href={CTA.href}>{CTA.label}</Link>
        </Button>
      </div>
    </motion.nav>
  );
}
